'use client';
import React from 'react';

import ListPage from '../../../../../components/page-components/list-page/list-page';
import { isDateTimeInFuture } from '../../../../../helpers/dates';
import { createListCardArray } from '../../../../../helpers/list-page/list-page-helpers';
import { pageIsOffer } from '../../../../../helpers/list-page/type-guards';
import useGetMobileAppWebViewHeader from '../../../../../hooks/use-get-mobile-app-web-view';
import { IMeetingPlacePageOfferList } from '@/lib/fragments/meetingPlacePageOfferList';
import { IMeetingPlacePageOccations } from '@/lib/fragments/meetingPlacePageOccations';
import { IMeetingplacePageHomeMinifiedExtendedLogo } from '@/lib/fragments/meetingPlacePageHome-minified';
import { IMeetingPlacePageOfferItem } from '@/lib/fragments/meetingPlacePageOfferItem';
import {
  useGetLibraryConstantsDictionaryData,
  useTenantConfig,
} from '@/providers/ConfigProvider';
import { GtmPageView } from '@/components/page-components/analytics/gtm-page-view';

interface MeetingPlacePageOfferListProps {
  metaData: any;
  node_locale: string;
  urlSubdirectory?: string;
  occasionId?: string;
  offerListData: {
    meetingPlacePageOfferList: IMeetingPlacePageOfferList | null;
    meetingPlacePageOccasions: IMeetingPlacePageOccations | null;
    meetingPlacePageHomeCollection: IMeetingplacePageHomeMinifiedExtendedLogo | null;
  };
  initialPage?: number;
  ikeaFamilyBenefit?:
  | import('@/lib/getIkeaFamilyBenefits').IkeaFamilyBenefitItem
  | null;
}

const MeetingPlacePageOfferList = ({
  metaData,
  node_locale,
  urlSubdirectory,
  occasionId,
  offerListData,
  initialPage,
  ikeaFamilyBenefit,
}: MeetingPlacePageOfferListProps) => {
  const config = useTenantConfig();
  const prefix = config?.GATSBY_SITE_PATH_PREFIX || '';
  const page = offerListData?.meetingPlacePageOfferList;
  const homepage = offerListData?.meetingPlacePageHomeCollection;
  const timezone = homepage?.meetingPlace?.timezone ?? '';
  const dictionary = useGetLibraryConstantsDictionaryData();

  const filteredOccations =
    offerListData?.meetingPlacePageOccasions &&
    offerListData?.meetingPlacePageOccasions?.occasionsCollection?.items.filter(
      Boolean,
    );

  const offerPagesInOccasionList =
    filteredOccations &&
    filteredOccations.filter((offer: any) => pageIsOffer(offer));

  let offerPages = offerPagesInOccasionList
    ? [...offerPagesInOccasionList]
    : [];

  page?.offerItemsCollection?.items?.forEach((page: any) => {
    const pageExists =
      offerPages.filter((item) => item?.sys?.id === page?.sys?.id).length > 0;
    if (!pageExists) offerPages.push(page);
  });

  offerPages = offerPages
    ?.map((offer) => offer as IMeetingPlacePageOfferItem) //Now, we can cast
    ?.map((offer) => {
      const isLivliFamily =
        config?.NEXT_PUBLIC_IS_MP_LIVLI_FAMILY === 'true' &&
        offer?.typeOfOffer?.internalName === 'specialOffer';
      return {
        ...offer,
        categories: [{ id: offer?.sys?.id, name: dictionary?.offers || '' }],
        livliFamily: isLivliFamily ? dictionary?.livliFamily : '',
      };
    }) // enable locale for Offers text. adding it as a dummy category
    ?.filter((offer) => isDateTimeInFuture(offer.validTo, timezone)); //Filter out those offers which validTo is before today

  const offerCardList = createListCardArray(
    offerPages,
    undefined,
    undefined,
    urlSubdirectory,
    node_locale,
    prefix,
  )?.map((card) =>
    card?.cardType === 'offer' && card?.tags?.some((tag) => tag?.tagName === 'Car Parking')
      ? { ...card, logo: homepage?.meetingPlace?.logo }
      : card,
  );

  const isWebView = useGetMobileAppWebViewHeader();

  return (
    <>
      {page && (
        <>
          <GtmPageView
            homepage={homepage}
            language={node_locale}
            pageTitle={page?.name ?? ''}
          />

          <ListPage
            cardList={offerCardList}
            pageName={page?.name}
            pageSlug={page?.slug}
            node_locale={node_locale}
            breadcrumbs={[page?.name]}
            homeText={homepage?.breadcrumbHomeText ?? ''}
            tileColClass="grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 items-start sm:items-stretch"
            listType="offer"
            businessUnitCode={homepage?.meetingPlace?.businessUnitCode}
            isWebView={isWebView}
            initialPage={initialPage ?? 1}
            ikeaFamilyBenefit={ikeaFamilyBenefit}
          />
        </>
      )}
    </>
  );
};

export default MeetingPlacePageOfferList;
